import { PagedResult } from '../../../shared/model/paged-result.model';
import { RegistrationMin } from './registration-min.model';

export class RegistrationSearchResult extends PagedResult {
  public Result: Array<RegistrationMin>;
  public RegistrationsWithoutProfileCount: number = 0;

  public constructor() {
    super();

    this.Result = new Array<RegistrationMin>();
  }
}
